import { captureException } from "@sentry/browser";
import { ApplicationInsightsService } from "@shared/application-insights-service";

const applicationInsights = new ApplicationInsightsService();

export function reportError(error: Error, message: string): void {
  applicationInsights.trackException(error, message);
  captureException(error, { level: "error", extra: { message } });
}

export function reportWarning(error: Error, message: string): void {
  applicationInsights.trackExceptionWarning(error, message);
  captureException(error, { level: "warning", extra: { message } });
}
